<template lang="pug">
    .box
        h5.title 重设密码
        ForgetForm(
            v-model="formData"
            :formType="2"
            @fn-handle="changeSubmitStatus"
        )
            ad-button.sure_btn(
                :disabled="!enableSubmit"
                @click="handleSubmit"
            ) 提交
            p.link-login(@click="goUrl('/login')")
                a.high_light 返回登录
</template>

<script type="text/javascript">
import ForgetForm from './LoginForm'
import { phoneReg, passwordReg } from '@/utils/fn'
import { resetPwd } from '@/utils/customerApi'

export default {
    name: 'ForgetPassword',
    components: { ForgetForm },
    data () {
        return {
            formData: {
                phoneNumber: '',
                smsVerifyCode: '',
                password: '',
                confirmPassword: ''
            },
            enableSubmit: false
        }
    },
    methods: {
        changeSubmitStatus (status) {
            this.enableSubmit = status
        },
        async handleSubmit () {
            const { password, confirmPassword, phoneNumber, smsVerifyCode } = this.formData
            if (!phoneReg.test(phoneNumber)) return this.messageTip('请输入正确的手机号')
            if (!passwordReg.test(password)) return this.messageTip('请输入8~20位含有大小写字母和数字的密码')
            if (confirmPassword !== password) return this.messageTip('请再次输入相同的确认密码')

            let opt = await this.encryptorProto({ password, confirmPassword })
            if (opt) {
                opt.phoneNumber = phoneNumber
                opt.smsVerifyCode = this.encode(smsVerifyCode)
                const res = await resetPwd(opt)
                if (res && res.code === 0) {
                    let _vm = this
                    this.$message({
                        type: 'success',
                        message: '密码重置成功',
                        duration: 2000,
                        onClose () {
                            _vm.goLogin()
                        }
                    })
                }
            }
        }
    }
}
</script>

<style lang="sass" scoped>
.title
    margin: 40px auto 6px
    color: #282729
    font-size: 28px
    line-height: 40px
    font-weight: 600
    text-align: center
.sure_btn
    margin-top: 30px !important
.link-login
    margin-top: 20px
    font-size: 14px
    line-height: 20px
    text-align: center
    .high_light
        margin: 0 4px
        color: $main-color
        cursor: pointer
</style>